import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class TheCryptGameMode extends GameMode {
    public static readonly NORMAL_AVALANCHE: string = "NORMAL_AVALANCHE";
    public static readonly FREESPIN_AVALANCHE: string = "FREESPIN_AVALANCHE";
}